import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import type { ClassValue } from "clsx"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Defaults to a same-origin relative path, which is correct both in
 * production (nginx proxies /api/* to the backend container - see
 * frontend/nginx.conf.template) and in local dev (vite.config.ts proxies
 * /api to localhost:8080). Only set VITE_API_URL to override with an
 * absolute URL if the backend is ever hosted on a different origin.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'